/* Emberly — scripts (vanilla, no dependencies) */
(function () {
  'use strict';

  var io = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.eb-reveal:not(.eb-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eb-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('eb-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var wrap = (root || document).querySelector('[data-eb-product]');
    if (!wrap || wrap.dataset.ebReady) return;
    wrap.dataset.ebReady = '1';

    var dataEl = wrap.querySelector('[data-eb-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = wrap.querySelector('form[data-eb-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceNow = wrap.querySelector('[data-eb-price]');
    var priceWas = wrap.querySelector('[data-eb-was]');
    var priceSave = wrap.querySelector('[data-eb-save]');
    var buttons = wrap.querySelectorAll('[data-eb-add]');
    var stickyPrice = wrap.querySelector('[data-eb-sticky-price]');
    var stickyVariant = wrap.querySelector('[data-eb-sticky-variant]');
    var track = wrap.querySelector('[data-eb-track]');
    var slides = Array.prototype.slice.call(wrap.querySelectorAll('[data-eb-slide]'));
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('[data-eb-thumb]'));
    var dotsEl = wrap.querySelector('[data-eb-dots]');
    var countEl = wrap.querySelector('[data-eb-count]');
    var soldText = wrap.dataset.soldText || 'Sold out';
    var addText = wrap.dataset.addText || 'Add to cart';
    var money = wrap.dataset.moneyFormat || '${{amount}}';

    function fmt(cents) {
      var n = (cents / 100).toFixed(2);
      return money.replace(/\{\{\s*amount\s*\}\}/, n)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
    }

    function selectedOptions() {
      var out = [];
      wrap.querySelectorAll('[data-eb-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        out.push(c ? c.value : null);
      });
      return out;
    }

    function currentVariant() {
      var sel = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    /* Gallery: show only the photos of the chosen color (matched by "(color)" in the alt text) */
    function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }

    function filterGallery(colorValue) {
      var key = (colorValue || '').toLowerCase();
      var any = slides.some(function (s) { return s.dataset.color === key; });
      slides.forEach(function (s, i) {
        var show = !any || !s.dataset.color || s.dataset.color === key;
        s.hidden = !show;
        if (thumbs[i]) thumbs[i].hidden = !show;
      });
      buildDots();
      if (track) track.scrollTo({ left: 0, behavior: 'auto' });
      updateGallery();
    }

    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      visibleSlides().forEach(function () { dotsEl.appendChild(document.createElement('i')); });
    }

    function updateGallery() {
      if (!track) return;
      var vs = visibleSlides();
      if (!vs.length) return;
      var w = track.clientWidth || 1;
      var idx = Math.max(0, Math.min(vs.length - 1, Math.round(track.scrollLeft / w)));
      if (dotsEl) Array.prototype.forEach.call(dotsEl.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      var active = vs[idx] && thumbs[slides.indexOf(vs[idx])];
      if (active) active.classList.add('is-active');
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + vs.length;
    }

    if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(updateGallery); }, { passive: true });
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var vs = visibleSlides();
        var pos = vs.indexOf(slides[i]);
        if (pos > -1 && track) track.scrollTo({ left: pos * track.clientWidth, behavior: 'smooth' });
      });
    });

    function update() {
      var v = currentVariant();
      var colorIdx = parseInt(wrap.dataset.colorOption || '-1', 10);
      var sel = selectedOptions();
      if (colorIdx > -1) filterGallery(sel[colorIdx]);
      else { buildDots(); updateGallery(); }

      wrap.querySelectorAll('[data-eb-selected]').forEach(function (el) {
        var i = parseInt(el.dataset.ebSelected, 10);
        el.textContent = sel[i] || '';
      });

      if (!v) {
        buttons.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = fmt(v.price);
      if (stickyPrice) stickyPrice.textContent = fmt(v.price);
      if (stickyVariant) stickyVariant.textContent = v.public_title || '';
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = fmt(v.compare_at_price); }
      if (priceSave) {
        priceSave.hidden = !onSale;
        if (onSale) priceSave.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
      }
      buttons.forEach(function (b) {
        b.disabled = !v.available;
        b.querySelector('span').textContent = v.available ? addText : soldText;
      });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    wrap.querySelectorAll('[data-eb-option] input').forEach(function (i) { i.addEventListener('change', update); });
    update();

    /* Sticky buy bar: appears once the main button leaves the screen */
    var sticky = wrap.querySelector('[data-eb-sticky]');
    var main = wrap.querySelector('[data-eb-main-add]');
    if (sticky && main && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(main);
    }
  }

  function boot(root) { initReveal(root); initProduct(root); }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
